import type { Struct } from 'superstruct';
import { mask, refine } from 'superstruct';

export function minimumValidatedArray<T, V>(
	arrayStruct: Struct<T>,
	validationStruct: Struct<V>,
	minimumValid: number
) {
	return refine(arrayStruct, '', (value) => {
		if (Array.isArray(value)) {
			let validCount = 0;

			for (const item of value) {
				try {
					mask(item, validationStruct);
					validCount++;
				} catch {
					continue;
				}
			}

			return (
				validCount >= minimumValid || 'validations:Minimum Valid Items Required'
			);
		}

		return true;
	});
}
